module.exports = __webpack_public_path__ + "img/clones-2029896_640.9655c28f.png";